<table class="totals-table bottom-spacer">
  <tbody>
    <tr>
      <td class="align-left">{{ 'general.api_cart_table_items_total' | translate }}:</td>
      <td class="align-right"><span class="price">{{ cartService.ticketQuantity | quantityInPcs }}</span></td>
    </tr>
    <tr *ngIf="cartService.ticketQuantity">
      <td class="align-left">{{ 'general.api_cart_table_items_price_total' | translate }}:</td>
      <td class="align-right"><span class="price">{{ cartService.cartTotalPrice | price }}</span></td>
    </tr>
    <tr *ngIf="cartService.cartFeesCompact && cartService.hasMultipleFees">
      <td class="align-left">
        <app-link *ngIf="canExpandCombinedFees" [icon]="isCompact ? 'arrow_right' : 'arrow_down'" (linkClicked)="isCompact = !isCompact">
        </app-link>{{cartService.cartFeesCompact.name | translateValue}}:
      </td>
      <td class="align-right">
        <span class="price">{{ cartService.cartFeesCompact.total | price }}</span>
      </td>
    </tr>
    <ng-container *ngIf="!isCompact || !cartService.hasMultipleFees">
      <tr *ngFor="let fee of cartService.cartFees">
        <td class="align-left">
          <div [ngClass]="{'indent-spacer': cartService.hasMultipleFees}">{{ fee.name | translateValue }}:</div>
        </td>
        <td class="align-right">
          <span class="price">{{ fee.total | price }}</span>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="authService.checkSalespointProperty('salespoint_uses_subtotals') && cartService.ticketQuantity">
      <td class="align-left">{{ 'general.api_cart_table_price_subtotal' | translate }}:</td>
      <td class="align-right"><span class="price">{{ cartService.cartSubTotal | price }}</span></td>
    </tr>
    <tr *ngFor="let fee of cartService.cartSalespointFees">
      <td class="align-left">{{ fee.name | translateValue }}:</td>
      <td class="align-right"><span class="price">{{ fee.total | price }}</span></td>
    </tr>
    <tr *ngIf="cartService.cartTotalDelivery">
      <td class="align-left">{{ 'general.api_reports_delivery_fee' | translate }}&nbsp;({{cartService.cartTotalDelivery.name | translate}}):</td>
      <td class="align-right"><span class="price">{{ cartService.cartTotalDelivery.price | price }}</span></td>
    </tr>
    <tr *ngIf="cartService.cart.giftCards?.length">
      <td class="align-left">{{ 'general.api_cart_table_giftticket_total' | translate }}:</td>
      <td class="align-right"><span class="price">{{ cartService.cartGiftCardCreditTotal * -1 | price }}</span></td>
    </tr>
    <tr *ngIf="cartService.cart.discountPercent">
      <td class="align-left">{{ 'general.api_cart_table_discount_total' | translate }}:</td>
      <td class="align-right"><span class="price">{{ cartService.cartTotalDiscount * -1 | price }}</span></td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <th class="align-left valign-top">{{ (cartService.totalSum >= 0 ? 'general.api_cart_table_price_total' : 'general.api_cart_table_price_total_return') | translate }}:</th>
      <td class="align-right valign-top"><span class="price">{{ cartService.ticketQuantity ? (cartService.totalSum | price) : '-' }}</span></td>
    </tr>
    <ng-container *ngIf="cartService.cart.total?.cashRounding">
      <tr class="prefix">
        <th class="align-left">{{ 'general.api_cart_table_cash_rounding' | translate }}:</th>
        <td class="align-right"><span class="price">{{ cartService.cart.total.cashRounding | price }}</span></td>
      </tr>
      <tr>
        <th class="align-left">{{ (cartService.totalSum >= 0 ? 'general.api_cart_table_price_total_in_cash' : 'general.api_cart_table_price_total_return_in_cash') | translate }}:</th>
        <td class="align-right"><span class="price">{{ cartService.ticketQuantity ? (cartService.totalSum + cartService.cart.total.cashRounding | price) : '-' }}</span></td>
      </tr>
    </ng-container>
  </tfoot>
</table>
